<template>
  <div class="card" v-if="metric && (businessUnit || creditor)">
    <div class="card-head border-0">
      <h2 class="h5 d-flex flex-row">
        {{ $t('dashboard.graph.title') }}
        <div v-if="creditor">
          <span class="color-warning">
            <icon name="angle-right" />
          </span>
          {{ creditor }}
        </div>
        <div v-if="businessUnit">
          <span class="color-warning">
            <icon name="angle-right" />
          </span>
          {{ businessUnit }}
        </div>
      </h2>
    </div>
    <div class="card-body border-0">
      <line-chart
        v-if="this.metric.type == 'line'"
        :data="[
          {
            name: businessUnit + ' ' + creditor,
            data: lineGraphData,
          },
        ]"
        :colors="['#4074AF', '#DDDB00']"
        :legend="false"
      ></line-chart>
      <div v-if="metric.type === 'gauge'">
        <gauge-chart
          :data="metric.data"
          :height="175"
          :width="350"
          :styles="{ height: '175px', width: '350px', margin: 'auto' }"
        />
        <div class="align-self-center text-center d-flex flex-column">
          <span v-text="$tc('days', Number(value.toFixed(1)))" />
          <div>
            <icon
              prefix="fas"
              :name="difference >= 0 ? 'caret-up' : 'caret-down'"
              :class="difference >= 0 ? 'text-success' : 'text-warning'"
            />
            <span v-text="Number(difference.toFixed(2).replace('-', '')) + '%'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Watch, Vue } from 'vue-property-decorator';
import { Metric } from '@/models';
import Icon from '@/components/global/Icon.vue';
import format from 'date-fns/format';
import GaugeChart from '@/components/charts/GaugeChart.vue';

@Component({
  components: {
    GaugeChart: GaugeChart as any,
    Icon,
  },
})
export default class DsoChart extends Vue {
  private async created() {
    await this.loadData();
  }

  private async loadData() {
    await this.$store.dispatch('dashboard/loadMetrics');
  }

  get businessUnit() {
    if (this.metric) {
      return this.metric.businessUnit || '';
    }
  }

  get creditor() {
    if (this.metric) {
      return this.metric.creditor || '';
    }
  }
  public get difference(): any {
    const lastMonth = Number(this.metric.data.dataSet[this.metric.data.dataSet.length - 2].value);
    const thisMonth = this.value;
    if (thisMonth && lastMonth) {
      return ((thisMonth - lastMonth) / lastMonth) * 100;
    }
    return 0;
  }

  get value() {
    return Number(this.metric.data.dataSet[this.metric.data.dataSet.length - 1].value);
  }
  get metric() {
    return this.$store.state.dashboard.metrics
      ? this.$store.state.dashboard.metrics.dsoMetrics
      : null;
  }
  get lineGraphData() {
    const data: any = {};
    if (this.metric) {
      this.metric.data.dataSet.forEach((item: any) => {
        data[format(new Date(item.timestamp.date), 'dd/MM/yyyy')] = item.value;
      });
    }
    return data;
  }
}
</script>